import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const requestTopicAttachmentSetAsWatched = async (id, type) => {
  // @ts-ignore
  return authorizedFetch({
    path: '/api/v1/creator_studio/courses/watched_attachment',
    method: REST_METHODS.POST,
    body: {
      attachmentable_type: type,
      attachmentable_id: id,
    },
  });
};

export default requestTopicAttachmentSetAsWatched;
